import type { ReactNode } from 'react';

import { ButtonBase } from '@/shared/ui';

import getFactsheetLink from '@/features/factsheet/lib/getFactsheetLink';
import { useFactsheetOpenState } from '@/features/factsheet/state/useFactsheetOpenState';

const FactsheetDialogButtonBase = ({
  code,
  children,
  mode = 'modal'
}: {
  code: string;
  children: ReactNode;
  mode?: 'modal' | 'newTab';
}) => {
  const { open } = useFactsheetOpenState();
  return (
    <ButtonBase
      onClick={e => {
        e.stopPropagation();
        if (mode === 'newTab') {
          window.open(getFactsheetLink(code), '_blank');
          return;
        }
        open(code);
      }}
    >
      {children}
    </ButtonBase>
  );
};
export default FactsheetDialogButtonBase;
